//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import './reportContentActive.css'
import { documentContentStoreMixin } from './documentContentStoreMixin.js'

export default {
  name: 'ReportContentItem',
  mixins: [documentContentStoreMixin],
  props: {
    node: {
      type: Object,
      required: true
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkActiveDescendant () {
      return this.contentGetter('hasActiveDescendant')
    },
    activeSectionId () {
      return this.contentGetter('getActiveSectionId')
    },
    expandedSectionsIds () {
      return this.contentGetter('getExpandedSectionsIds')
    },
    getSectionIcon () {
      return this.contentGetter('getSectionIcon')
    },
    hasChildren () {
      return this.node.children && this.node.children.length > 0
    },
    isExpanded () {
      return this.expandedSectionsIds.includes(this.node.id)
    },
    isActive () {
      return this.isNavigable && this.activeSectionId === this.node.id
    },
    hasActiveDescendant () {
      return this.checkActiveDescendant(this.node.id)
    },
    isNavigable () {
      return !this.node.groupingOnly
    },
    textClasses () {
      return {
        'text-primary text-weight-bold': this.isActive || (this.hasActiveDescendant && !this.isExpanded)
      }
    },
    headerClasses () {
      return {
        'report-content-item--active': this.isActive,
        'report-content-item--active-parent': !this.isActive && this.hasActiveDescendant && !this.isExpanded
      }
    },
    itemRowClasses () {
      return {
        'row items-center': true,
        'no-wrap': !this.mobile,
        'report-content-item-row--mobile': this.mobile
      }
    },
    iconUrl () {
      if (this.node.icon) {
        return this.node.icon
      } else {
        return this.getSectionIcon(this.node.id)
      }
    }
  },
  methods: {
    setActiveSection (id) {
      return this.contentDispatch('setActiveSection', id)
    },
    setNodeExpanded (payload) {
      return this.contentDispatch('setNodeExpanded', payload)
    },
    onExpandedChange (expanded) {
      this.setNodeExpanded({
        id: this.node.id,
        expanded
      })
    },
    onNodeClick () {
      this.setActiveSection(this.node.id)
      this.$emit('navigate', this.node.id)
    }
  }
}
